(() => {
  if (window.signaturePageInitialized) return;
  window.signaturePageInitialized = true;
  const cleanups = new WeakMap();
  const sections = (root, selector) => [
    ...(root.matches && root.matches(selector) ? [root] : []),
    ...root.querySelectorAll(selector)
  ];
  function init(root) {
    sections(root, '[data-sig-carousel]').forEach(section => {
      if (cleanups.has(section)) return;
      // theme.liquid loads the bundled Swiper synchronously before page sections.
      if (typeof window.Swiper !== 'function') return;
      const viewport = section.querySelector('.sig-products__viewport');
      const prev = section.querySelector('[data-sig-prev]');
      const next = section.querySelector('[data-sig-next]');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const spacing = () => window.innerWidth * (
        matchMedia('(max-width: 768px)').matches ? 26 / 1242 : 20 / 1920
      );
      const swiper = new window.Swiper(viewport, {
        slidesPerView: 'auto',
        spaceBetween: spacing(),
        speed: reducedMotion.matches ? 0 : 400,
        watchOverflow: true,
        navigation: { prevEl: prev, nextEl: next },
        a11y: { enabled: true },
        on: {
          beforeResize(instance) { instance.params.spaceBetween = spacing(); }
        }
      });
      const keyboard = event => {
        if (event.target !== viewport || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'ArrowLeft') swiper.slidePrev();
        else swiper.slideNext();
      };
      const motion = () => { swiper.params.speed = reducedMotion.matches ? 0 : 400; };
      viewport.addEventListener('keydown', keyboard);
      reducedMotion.addEventListener('change', motion);
      cleanups.set(section, () => {
        viewport.removeEventListener('keydown', keyboard);
        reducedMotion.removeEventListener('change', motion);
        swiper.destroy(true, true);
        prev.disabled = false;
        next.disabled = false;
      });
    });
    sections(root, '[data-sig-marquee]').forEach(section => {
      if (cleanups.has(section)) return;
      const group = section.querySelector('.sig-moments__group');
      const clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
      section.querySelector('.sig-moments__track').append(clone);
      const viewport = section.querySelector('.sig-moments__viewport');
      const button = section.querySelector('[data-sig-pause]');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: controller.signal });
      let frame;
      let previousTime;
      let interactingUntil = 0;
      let hovered = false;
      let touching = false;
      let drag = null;
      let position = viewport.scrollLeft;
      const interact = () => { interactingUntil = performance.now() + 1500; };
      listen(viewport, 'scroll', () => { position = viewport.scrollLeft; }, { passive: true });
      listen(viewport, 'wheel', interact, { passive: true });
      listen(viewport, 'pointerenter', event => { if (event.pointerType === 'mouse') hovered = true; });
      listen(viewport, 'pointerleave', () => { hovered = false; });
      listen(viewport, 'pointerdown', event => {
        interact();
        touching = true;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { x: event.clientX, scroll: viewport.scrollLeft };
        viewport.setPointerCapture(event.pointerId);
        viewport.dataset.dragging = 'true';
        event.preventDefault();
      });
      listen(viewport, 'pointermove', event => {
        if (!drag) return;
        viewport.scrollLeft = drag.scroll + drag.x - event.clientX;
        position = viewport.scrollLeft;
      });
      const release = () => {
        touching = false;
        drag = null;
        delete viewport.dataset.dragging;
        interact();
      };
      listen(window, 'pointerup', release);
      listen(window, 'pointercancel', release);
      listen(viewport, 'lostpointercapture', release);
      listen(viewport, 'keydown', interact);
      const animate = time => {
        const elapsed = previousTime === undefined ? 0 : Math.min(time - previousTime, 50);
        previousTime = time;
        const period = clone.offsetLeft - group.offsetLeft;
        const paused = reducedMotion.matches || document.hidden || hovered || touching ||
          section.dataset.paused === 'true' || section.contains(document.activeElement) || time < interactingUntil;
        if (!paused && period > 0 && group.scrollWidth > viewport.clientWidth) {
          position = (position + elapsed * period / 240000) % period;
          viewport.scrollLeft = position;
        }
        frame = requestAnimationFrame(animate);
      };
      frame = requestAnimationFrame(animate);
      const toggle = () => {
        const paused = section.dataset.paused !== 'true';
        section.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? 'Resume gallery' : 'Pause gallery';
      };
      button.addEventListener('click', toggle);
      cleanups.set(section, () => {
        cancelAnimationFrame(frame);
        controller.abort();
        clone.remove();
        delete viewport.dataset.dragging;
        button.removeEventListener('click', toggle);
      });
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    sections(event.target, '[data-sig-carousel], [data-sig-marquee]').forEach(section => {
      const cleanup = cleanups.get(section);
      if (cleanup) cleanup();
      cleanups.delete(section);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
